import angular from 'angular';
import { eDropdown } from './e-dropdown.component';

export default angular.module('eDropdown', [])
  .component(eDropdown.selector, eDropdown);



/** WEBPACK FOOTER **
 ** ./src/core/components/e-dropdown/index.js
 **/